module.exports = __webpack_public_path__ + "static/media/BrownTS_2017_BrownsGeneralizedVitalsEquation.e0fa387c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/informatics/BrownTS_2017_BrownsGeneralizedVitalsEquation.pdf
// module id = 405
// module chunks = 0